import { createSlice } from "@reduxjs/toolkit";

const vendorsSlice = createSlice({
  name: "vendors",
  initialState: {
    vendors: [],
    loaded: false,
    status: "idle",
    error: null,
  },
  reducers: {
    setVendors: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.vendors = action.payload;
      state.loaded = true;
      state.status = "ready";
      state.error = null;
    },
    setVendorsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearVendors: (state) => {
      state.vendors = [];
      state.loaded = false;
      state.status = "idle";
      state.error = null;
    },
    upsertVendor: (state, action) => {
      const v = action.payload;
      if (!v || typeof v !== "object" || !Array.isArray(state.vendors)) return;
      const idx = state.vendors.findIndex((x) => x.uuid === v.uuid);
      if (idx >= 0) state.vendors[idx] = { ...state.vendors[idx], ...v };
      else state.vendors.unshift(v);
    },
    removeVendor: (state, action) => {
      state.vendors = state.vendors.filter((x) => x.uuid !== action.payload);
    },
  },
});

export const { setVendors, setVendorsStatus, clearVendors, upsertVendor, removeVendor } =
  vendorsSlice.actions;
export default vendorsSlice.reducer;
